import { Box, Grid, Typography, Theme } from '@mui/material';
import { SubHeading } from '../../investors/components';
import React from 'react';
import { Item, ItemDetails, Gridstyles } from '../index';
import { Applicant, ApplicationProps } from '../../../redux-store/types/api-types';
import { formatShortDate } from '../../../utils/date';
import { SxProps } from '@mui/system';
import {
  applicantStatusMasters,
  ApplicationSourceMaster,
  isNaturalParent,
  ONBOARDING_ID_TYPES_MASTER,
  taxResidencyDocumentTypeMaster,
  USER_ROLES,
  USPersonDateValidation,
} from '../../../utils/constant';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import {
  checkNonResident,
  checkValidationBasedOnDate,
  isFatherMother,
  isIdTypeOutOfList,
  isOnboardingTypeMinor,
  isRiOutboundFund,
} from '../../../utils/utilityFunctions';

export const KeyValue = ({
  title,
  description,
  amount,
  sx = {},
  descriptionSx = {},
}: {
  title: string | undefined;
  description?: string[] | string | number | boolean | null;
  amount?: number | null | undefined | string;
  sx?: SxProps<Theme>;
  descriptionSx?: SxProps<Theme>;
}): JSX.Element => {
  return (
    <Grid item xs={12} sm={6}>
      <Item sx={sx}>{title}</Item>
      <ItemDetails sx={descriptionSx}>
        {' '}
        {description || description === 0 ? description : '-'}
      </ItemDetails>
      {!!amount && amount !== 0 && <Item sx={{ pt: 0 }}> {amount}</Item>}
    </Grid>
  );
};

export default function ContributorDetails({
  application,
  modeOfHolding,
  applicationSource,
  ifXalt,
}: {
  application: ApplicationProps;
  modeOfHolding: string;
  applicationSource: string | undefined;
  ifXalt: boolean;
}): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Mode of Holding:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                    textTransform: 'capitalize',
                  }}>
                  {modeOfHolding === 'either or survivor' ? 'Joint' : modeOfHolding || 'Single'}
                </Typography>
              </Typography>
              {/* {USER_ROLES.INVESTOR !== role && (
                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: 'text.secondary',
                  }}>
                  Application Source:{' '}
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: 500,
                      fontSize: '16px',
                      color: 'rgba(0, 0, 0, 0.6)',
                      letterSpacing: '0.4px',
                      ml: 0.5,
                    }}>
                    {applicationSource ? ApplicationSourceMaster[applicationSource] : 'N/A'}
                  </Typography>
                </Typography>
              )} */}
            </Grid>
            {application.applicants?.map((applicant, index: number) => {
              const title = isOnboardingTypeMinor(application?.onboardingType)
                ? 'Contributor Details of Guardian'
                : [
                    'First Applicant Details',
                    'Second Applicant Details',
                    'Third Applicant Details',
                  ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {title}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name'} description={applicant.name} />
                      <KeyValue title={'Gender'} description={applicant.gender} />
                      <KeyValue
                        title={'Date Of Birth'}
                        description={formatShortDate(applicant.dateOfBirth)}
                      />
                      <KeyValue
                        title={'Father/Spouse Name'}
                        description={applicant.fatherOrSpouseName}
                      />
                      <KeyValue title={'Mother Name'} description={applicant.motherName} />
                      <KeyValue
                        title={`${
                          applicant.onboardingIdType && applicant.onboardingIdType
                            ? !isIdTypeOutOfList(applicant.onboardingIdType || '')
                              ? ONBOARDING_ID_TYPES_MASTER[applicant.onboardingIdType || '']
                              : applicant?.onboardingIdTypeOthers
                            : 'Id Number'
                        }`}
                        description={applicant.taxIdNumber}
                      />
                      <KeyValue title={'Status'} description={applicant.status} />
                      <KeyValue
                        title={'Country of Nationality of Applicant'}
                        description={applicant.nationality}
                      />
                      {index !== 0 && (
                        <KeyValue
                          title={'RelationShip With First Applicant'}
                          description={applicant.relationShipWithFirstApplicant}
                        />
                      )}
                      {applicant.panDeclaration ? (
                        <Grid item xs={12} display="flex" alignItems={'flex-start'} mt={1}>
                          {/* <Checkbox defaultChecked disabled={true} /> */}
                          <Typography
                            sx={{
                              fontSize: 15,
                              fontWeight: 700,
                              color: 'rgba(0, 0, 0, 0.6)',
                              letterSpacing: '0.5px',
                            }}>
                            {
                              'I, hereby declare that I do not hold a Permanent Account Number (PAN) card. I am making this declaration in accordance with the requirements of Form 49BA under Income Tax Rules for the purpose of investment in Fund.I understand that not having a PAN card necessitates the submission of Form 49BA by the Registered Intermediary to fulfill the regulatory requirements for the transaction in question. I undertake to provide all necessary details and supporting documents as required by the relevant authorities.'
                            }
                          </Typography>
                        </Grid>
                      ) : (
                        <KeyValue title={'PAN'} description={applicant.pan} />
                      )}
                      {checkNonResident(applicant.status) && (
                        <KeyValue
                          title={`Tax Residency Document Type`}
                          description={
                            taxResidencyDocumentTypeMaster[applicant.taxResidencyDocumentType || '']
                          }
                        />
                      )}
                      {checkValidationBasedOnDate(
                        application?.createdAt || '',
                        USPersonDateValidation
                      ) &&
                        !isRiOutboundFund(applicant.status, application?.scheme?.id) && (
                          <KeyValue
                            title={'Are You a US Person'}
                            description={applicant.usPerson}
                          />
                        )}
                    </Grid>
                  </Gridstyles>
                  {isOnboardingTypeMinor(application?.onboardingType) && (
                    <>
                      <SubHeading
                        sx={{
                          color: 'common.black',
                          letterSpacing: 0.5 + 'px',
                          padding: { xs: '10px 10px', sm: '10px 30px' },
                        }}>
                        Contributor Details of Minor Applicant
                      </SubHeading>
                      <Gridstyles>
                        <Grid
                          item
                          container
                          pb={5}
                          rowSpacing={6}
                          columnSpacing={13}
                          direction="row"
                          justifyContent="space-between"
                          alignItems="flex-start">
                          <KeyValue title={'ID Number'} description={applicant.minorPan} />
                          <KeyValue
                            title={'Date of Birth'}
                            description={formatShortDate(applicant.minorDOB)}
                          />
                          <KeyValue title={'Full Name'} description={applicant.minorName} />
                          <KeyValue title={'Father Name'} description={applicant.minorFatherName} />
                          <KeyValue title={'Gender'} description={applicant.minorGender} />
                          <KeyValue title={'Email ID'} description={applicant.minorEmail} />
                          <KeyValue
                            title={'Mobile Number'}
                            description={
                              applicant.minorCountryCode && applicant.minorMobile
                                ? applicant.minorCountryCode + '-' + applicant.minorMobile
                                : applicant.minorMobile
                            }
                          />
                          <KeyValue
                            title={
                              ifXalt
                                ? 'Guardian Relationship with Minor'
                                : 'Relationship with Guardian'
                            }
                            description={applicant.guardianRelationship}
                          />
                          {isFatherMother(applicant.guardianRelationship || '') && (
                            <KeyValue
                              title={'Natural Parents'}
                              description={isNaturalParent[applicant.naturalParent || '']}
                            />
                          )}
                        </Grid>
                      </Gridstyles>
                    </>
                  )}
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
